import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { getColor } from "./chart-colors";
import { formatValue } from "./format-value";

/**
 * @param {{
 *   spec: Object,
 *   data: Object[],
 *   height?: number|string,
 *   customTooltip?: React.ReactElement,
 *   options?: { barGap?: string|number, interval?: number }
 * }} props
 */
const ChartBar = ({ spec, data, height = 300, customTooltip, options = {} }) => {
    const { xAxis, series = [], formatting } = spec;
    const valueType = formatting?.valueType;
    const { barGap, interval } = options;

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart
                data={data}
                barGap={barGap}
                margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey={xAxis?.key} interval={interval} tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => formatValue(v, valueType)} />
                {customTooltip || (
                    <Tooltip formatter={(v, name) => [formatValue(v, valueType), name]} />
                )}
                <Legend />
                {series.map((s, i) => (
                    <Bar
                        key={s.key}
                        dataKey={s.key}
                        name={s.label}
                        fill={s.color || getColor(i)}
                        stackId={s.stackId}
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ChartBar;
